const NODE_ID = 'yd-portal__announcements'
const NODE_ID_ASSERTIVE = 'yd-portal__announcements--assertive'

const getNodeId = (isAssertive: boolean) =>
  isAssertive ? NODE_ID_ASSERTIVE : NODE_ID

const createAnnouncementNode = (isAssertive: boolean) => {
  const node = document.createElement('div')

  node.id = getNodeId(isAssertive)
  node.classList.add('sr-only')
  node.setAttribute('aria-atomic', 'true')
  node.setAttribute('aria-live', isAssertive ? 'assertive' : 'polite')

  document.body.append(node)

  return node
}

export const srAnnounce = (
  msg: string,
  options: {
    assertive?: boolean
  } = {}
) => {
  if (process.env.NODE_ENV !== 'test') {
    const { assertive = false } = options

    const nodeId = getNodeId(assertive)
    const announcementNode =
      document.getElementById(nodeId) || createAnnouncementNode(assertive)

    announcementNode.innerHTML = ''
    announcementNode.innerHTML = msg
  }
}
